export type FetchStripeOnboardingLinkResponse = {
  onboardingLink: string;
};

const baseUrl = '/api/proxy/v3/stripe/links';

export async function fetchStripeOnboardingLink(
  from?: string
): Promise<FetchStripeOnboardingLinkResponse> {
  try {
    const url = from ? `${baseUrl}?from=${from}` : baseUrl;
    const response = await fetch(url, {
      method: 'GET',
    });

    if (response.ok) {
      return response.json();
    }
    throw new Error(`Could not retrieve onboarding link from Stripe.`);
  } catch (err) {
    throw new Error(err.message);
  }
}
